module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_home-46df0b5040f3b3c687060b8dcbec500a.svg";